import _ from 'lodash';
import { hydrateObjects, cleanUpJsonForTransport } from '../json-helper';

import users from './users.json';

export class UserApi {
    constructor(instance, inProgress, accounts, forceRefresh) {

        this.users = cleanUpJsonForTransport(Object.assign([], hydrateObjects(users)));
    }

    user = id => {

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars

            if(id !== "all"){
                const user = _.find(this.users, u => u.id === id);
                return resolve(user);
            }
            else{
                return resolve(this.users);
            }
        });
    }

    updateUser = user => {

        const userDoc = structuredClone(user);

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars

            const userIndex = _.findIndex(this.users, u => u.id === userDoc.id);
            if (userIndex > -1) {

                this.users.splice(userIndex, 1, userDoc);
                const newUser = _.find(this.users, u => u.id === userDoc.id);
                return resolve(newUser);
            }

            return reject("User not updated");
        });

    };
}